import { Type } from "class-transformer";
import { PlotAxisDefinition } from "./PlotAxisDefinition";
import { PlotType } from "./PlotType";

export class PlotDefinition {
    name: string;
    type: PlotType = PlotType.line;
    @Type(() => PlotAxisDefinition)
    xAxis: PlotAxisDefinition = new PlotAxisDefinition();
    @Type(() => PlotAxisDefinition)
    yAxis: PlotAxisDefinition = new PlotAxisDefinition();
    colorBy: string;
    opacity = 1;
}
